export default "__VITE_ASSET__2fbaf35b__"